import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { FormProvider, useForm } from "react-hook-form";
import { FilterCriteria } from "./FilterCriteria";
import { OtherSettings } from "./OtherSettings";
import config from "../../Config/clientConfig.json";
import WSSelectField from "../../Components/Select/WSSelect";
import WSDateField from "../../Components/DateField/WSDateField";
import WSRadioField from "../../Components/Radio/WSRadio";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";

export const MenuItemSalesReport:React.FC<any>=React.memo((props)=>{
  const { handleSubmit, control, register } = useForm();
   
      const onSubmit = async (data: any) => {
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };
    return(
              <form onSubmit={handleSubmit(onSubmit)}  style={{ width: '100%' }}>

                <Typography sx={{fontWeight: 500,fontSize: "0.875rem",color:"#1976d2"}}>FILTER CRITERIA</Typography>
                <Divider sx={{mt:1}}/>
                <Grid container spacing={2} sx={{mt:3}}>
                <Grid item xs={12} sm={2}>
        <Typography>Report Type</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("reporttype")}
          id="reporttype"
          control={control}
          defaultValue={"0"}
          label=""
          name="reporttype"
          options={config.menureporttypeConfig.staticOptionData}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Category</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("category")}
          id="category"
          control={control}
          defaultValue={"0"}
          label=""
          name="category"
          options={config.categoryConfig.staticOptionData}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>From Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="fromdate"
          name="fromdate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>To Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="todate"
          name="todate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
     
      <Grid item xs={12} sm={6}>
                <Grid container spacing={2}>
                    
                    <Grid item xs={12} sm={6}>
                    <WSSCheckBoxField
          id="showitemdescription"
          name="showitemdescription"
          label="Show Item Description"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                    <WSSCheckBoxField
          id="ignoremdifier"
          name="ignoremdifier"
          label="Ignore Modifier Without Cost"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    <WSSCheckBoxField
          id="sortbycategory"
          name="sortbycategory"
          label="Sort By Category"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                    <WSSCheckBoxField
          id="showweightpercentage"
          name="showweightpercentage"
          label="Show Weight Percentage"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
                    </Grid>

                    
                </Grid>
            </Grid>

            <Grid item xs={12} sm={3}>
                <WSRadioField
                    id="radio"
                    name="radio"
                    label=""
                    control={control}
                    defaultValue={"radio"}
                    options={config.menureportConfig.staticOptionData}
                    rules={{ required: true }}
                />
            </Grid>
      </Grid>
            </form>
    )
})